import '../css/app.scss';

import 'bootstrap/dist/js/bootstrap.min.js';

import jPlayer from 'jplayer';

/*!
 * jQuery.ellipsis
 * http://github.com/jjenzz/jquery.ellipsis
 * --------------------------------------------------------------------------
 * Copyright (c) 2013 J. Smith (@jjenzz)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * adds a class to the last 'allowed' line of text so you can apply
 * text-overflow: ellipsis;
 */
(function(e){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],e)}else{e(jQuery)}})(function(e){"use strict";function i(i,s){function g(){o.text=o.$cont.text();o.opts.ellipLineClass=o.opts.ellipClass+"-line";o.$el=e('<span class="'+o.opts.ellipClass+'" />');o.$el.text(o.text);o.$cont.empty().append(o.$el);y()}function y(){if(typeof o.opts.lines==="number"&&o.opts.lines<2){o.$el.addClass(o.opts.ellipLineClass);return}d=o.$cont.height();if(o.opts.lines==="auto"&&o.$el.prop("scrollHeight")<=d){return}if(!f){return}v=e.trim(w(o.text)).split(/\s+/);o.$el.html(n+v.join("</span> "+n)+"</span>");o.$el.find("span").each(f);if(l!=null){b(l)}}function b(e){v[e]='<span class="'+o.opts.ellipLineClass+'">'+v[e];v.push("</span>");o.$el.html(v.join(" "))}function w(e){return String(e).replace(/[&<>"'\/]/g,function(e){return m[e]})}var o=this,u=0,a=[],f,l,c,h,p,d,v,m;m={"&":"&","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"};o.$cont=e(i);o.opts=e.extend({},r,s);if(o.opts.lines==="auto"){var E=function(t,n){var r=e(n),i=r.position().top;p=p||r.height();if(i===h){a[u].push(r)}else{h=i;u+=1;a[u]=[r]}if(i+p>d){l=t-a[u-1].length;return false}};f=E}if(typeof o.opts.lines==="number"&&o.opts.lines>1){var S=function(t,n){var r=e(n),i=r.position().top;if(i!==h){h=i;u+=1}if(u===o.opts.lines){l=t;return false}};f=S}if(o.opts.responsive){var x=function(){a=[];u=0;h=null;l=null;o.$el.html(w(o.text));clearTimeout(c);c=setTimeout(y,100)};e(window).on("resize."+t,x)}g()}var t="ellipsis",n='<span style="white-space: nowrap;">',r={lines:"auto",ellipClass:"ellip",responsive:false};e.fn[t]=function(n){return this.each(function(){try{e(this).data(t,new i(this,n))}catch(r){if(window.console){console.error(t+": "+r)}}})}});

/*!
 * IE10 viewport hack for Surface/desktop Windows 8 bug
 * Copyright 2014-2017 The Bootstrap Authors
 * Copyright 2014-2017 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

// See the Getting Started docs for more information:
// https://getbootstrap.com/getting-started/#support-ie10-width

(function () {
  'use strict'
  if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style')
    msViewportStyle.appendChild(
      document.createTextNode(
        '@-ms-viewport{width:auto!important}'
      )
    )
    document.head.appendChild(msViewportStyle)
  }
}());

//Custom functions
function setClicks() {
	$('[id^=scrollTo]').click(function() {
		var id = $(this).attr('id').slice(9);
		$(window).scrollTo($('#' + id), 1000, { offset: { top: -51, left: 0 } });
	});

	$('[data-toggle="offcanvas"]').click(function () {
        $('.row-offcanvas').toggleClass('active');
        $('html, body').animate({
            scrollTop: 0
        }, 800);
	});

  $(".flyout-btn").click(function(n){
    n.preventDefault(); n.stopPropagation();
    $(this).find("i").toggleClass("fa-plus fa-minus");
    const myMenu = $(this).parent().find(".flyout-menu");
    if(!myMenu.hasClass("show")){
      myMenu.addClass("show");
    }
    else {
      myMenu.removeClass("show");
    }
  });
}

function cleanMenu() {
  $(".flyout-menu.show").removeClass("show");
  $(".flyout-btn i.fa-minus").removeClass("fa-minus").addClass("fa-plus");
}

var updatePlayer = function (src, title) {
    // var player = $("#jquery_jplayer_1");
    jPPlayer.jPlayer("setMedia", {
        mp3: src,
        title: title
    });
    ellipsis();
    // player.jPlayer("play", 0);
}
function ellipsis() {
    $(".jp-title, #jp-up-next-item").ellipsis({
        lines: 1,
        ellipClass: 'ellip',
        responsive: true
    });
}
var initLivePlayer = function (first_start) {
    var player = $("#jquery_jplayer_1");
    if (first_start)
    {
        player.jPlayer({
            ready: function () {
                $(this).jPlayer("setMedia", {
                    mp3: latestMP3,
                    title: latestTitle
                });
                ellipsis();
            },
            play: function() {
                if (!playingNow.episode) return;
                var img = $('a[attr-episode-id="'+playingNow.episode+'"] img');
                img.attr('src', img.attr('attr-pause-icon'));
                playingNow.state = 'playing';
            },
            pause: function() {
                if (!playingNow.episode) return;
                var img = $('a[attr-episode-id="'+playingNow.episode+'"] img');
                img.attr('src', img.attr('attr-play-icon'));
                playingNow.state = 'paused';
            },
            cssSelectorAncestor: "#jp_container_1",
            swfPath: "vendor/jplayer",
            supplied: "mp3",
            useStateClassSkin: true,
            autoBlur: false,
            captureDuration: false,
            smoothPlayBar: true,
            keyEnabled: true,
            remainingDuration: false,
            toggleDuration: false,
            autoPlay: false
        });
    }
    else
    {
        updatePlayer(latestMP3, latestTitle);
        player.jPlayer('play');
    }
    // var player = $("#jquery_jplayer_1");
    // console.log(first_start);

    // $.get('https://chc.airtime.pro/api/live-info-v2', function (data) {
    //     var currentName = data.tracks.current.name;
    //     console.log(data);
    //     if (first_start) {
    //         player.jPlayer({
    //             ready: function () {
    //                 $(this).jPlayer("setMedia", {
    //                     mp3: 'https://chc.out.airtime.pro/chc_a',
    //                     title: currentName
    //                 });
    //                 ellipsis();
    //             },
    //             play: function() {
    //                 if (!playingNow.episode) return;
    //                 var img = $('a[attr-episode-id="'+playingNow.episode+'"] img');
    //                 img.attr('src', img.attr('attr-pause-icon'));
    //                 playingNow.state = 'playing';
    //             },
    //             pause: function() {
    //                 if (!playingNow.episode) return;
    //                 var img = $('a[attr-episode-id="'+playingNow.episode+'"] img');
    //                 img.attr('src', img.attr('attr-play-icon'));
    //                 playingNow.state = 'paused';
    //             },
    //             cssSelectorAncestor: "#jp_container_1",
    //             swfPath: "vendor/jplayer",
    //             supplied: "mp3",
    //             useStateClassSkin: true,
    //             autoBlur: false,
    //             captureDuration: false,
    //             smoothPlayBar: true,
    //             keyEnabled: true,
    //             remainingDuration: false,
    //             toggleDuration: false,
    //             autoPlay: false
    //         });
    //     } else {
    //         updatePlayer('https://chc.out.airtime.pro/chc_a', currentName);
    //         player.jPlayer('play');
    //     }
    // })
};

var pageCache = {};
$(document).ready(function () {
    var path = window.location.pathname + window.location.search;
    pageCache[path] = $('#js-content-container').html();
    initLivePlayer(true);
});
window.onpopstate = history.onpushstate = function(e) {
    var path = e.target.location.pathname + e.target.location.search;

    ajaxer({
        href: path,
        action: 'state'
    });
};
var ajaxer = function (argument) {
    var container = $('#js-content-container');
    if (pageCache[argument.href] != undefined && argument.action === 'state') {
        container.html(pageCache[argument.href]);
        setMetaData(container);
        loadEpisodesOnPlay();
    } else {
        if (argument.current == argument.href) return null;
        $.get(argument.href, function (response) {
            container.html(response);
            pageCache[argument.href] = response;
            window.history.pushState(null, null, argument.href);
            setMetaData(container);
            loadEpisodesOnPlay();
        });
    }
    return null;
};

var playingNow = {};
var playerWasInitiated = false;
var initedElement = {};
var jPPlayer = $("#jquery_jplayer_1");
var loadEpisodesOnPlay = function () {
    if (!playingNow.episode) return;
    var img = $('a[attr-episode-id="'+playingNow.episode+'"] img');
    if (playingNow.state === 'playing') img.attr('src', img.attr('attr-pause-icon'));
    else img.attr('src', img.attr('attr-play-icon'));
};

var playEpisode = function (element) {
    if (playingNow.episode && (playingNow.episode !== element.attr('attr-episode-id'))) {
        var pausedImg = $('a[attr-episode-id="'+playingNow.episode+'"] img');
        pausedImg.attr('src', pausedImg.attr('attr-play-icon'));
    }
    playingNow = { episode: element.attr('attr-episode-id'), state: 'playing' };
    var img = element.find('img');
    img.attr('src', img.attr('attr-pause-icon'));
    jPPlayer.jPlayer('play');
    playerWasInitiated = true;
    initedElement = element;
};

var pauseEpisode = function (element, onVideo) {
    if (!onVideo) playingNow = { episode: element.attr('attr-episode-id'), state: 'paused' };
    var img = element.find('img');
    img.attr('src', img.attr('attr-play-icon'));
    jPPlayer.jPlayer('pause');
    if (!onVideo) playerWasInitiated = false;
};

var setMetaData = function(container) {
    var title, image, descr;
    title = container.find('#titleMeta').text();
    image = container.find('#imageMeta').text();
    descr = container.find('#descriptionMeta').text();
    $('title').text(title);
    $('meta[property="og:title"], meta[name="twitter:title"]').attr('content', title);
    $('meta[property="og:image"], meta[name="twitter:image"]').attr('content', image);
    $('meta[property="og:description"], meta[name="twitter:description"], meta[name="description"]').attr('content', descr);
};

$(document).on('click', '.js-nav-link', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var href = $(this).attr('href');
    ajaxer({
        href: href,
        action: 'click',
        current: window.location.pathname + window.location.search
    });
    $('html, body').animate({
        scrollTop: 0
    }, 800);
    if ($(".row-offcanvas-left").hasClass("active"))
        $('[data-toggle="offcanvas"]').click();
    return false;
});

$(document).on('click', 'a[modal-id]', function (e) {
    var element = $(this),
        modalId = element.attr('modal-id'),
        iframe = document.getElementById('iframe'+modalId),
        player = new Vimeo.Player(iframe);

    $('#video'+modalId).on('hide.bs.modal', function (e) {
        player.pause();
        if (playerWasInitiated) playEpisode(initedElement);
    });

    $('#video'+modalId).on('shown.bs.modal', function (e) {
        pauseEpisode(element, true);
        player.play();
    });
});

$(document).on('click', 'a[attr-audio]', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    // текущий эпизод
    if (playingNow.episode === $(this).attr('attr-episode-id')) {
        if (playingNow.state === 'paused') playEpisode($(this));
        else pauseEpisode($(this));
    } else {
        var src = $(this).attr('attr-audio');
        var title = $(this).attr('attr-title');
        updatePlayer(src, title);
        playEpisode($(this));
    }
});

$(document).on('click', '.jp-state-playing .jp-play', function (e) {
    pauseEpisode(initedElement);
});

$(document).on('click', '.js-listen-live', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (playingNow.episode) {
        var img = $('a[attr-episode-id="'+playingNow.episode+'"] img');
        img.attr('src', img.attr('attr-play-icon'));
        playingNow = {};
    }
    initLivePlayer(false);
});

$(document).on('submit', '.js-contact-form', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $.post('/contact.php', $(this).serialize(), function (data) {
        $('#js-content-container').html(data);
    })
});

$(document).on('click', '.js-search', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var href = '/search.php?query=' + $(this).parent().parent().find('input').val()
    ajaxer({
        href: href,
        action: 'click',
        current: window.location.pathname + window.location.search
    });
    if ($(".row-offcanvas-left").hasClass("acitve"))
        $('[data-toggle="offcanvas"]').click();
});

function doSearch(e) {
    if (e.keyCode == 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var href = '/search.php?query=' + $("#search-input").val()
        ajaxer({
            href: href,
            action: 'click',
            current: window.location.pathname + window.location.search
        });
    }
}

//init
$(function() {
  setClicks();
  // setPlayer(null);
  // getLiveData()
    $("#search-input").keypress(function (event) {
        doSearch(event);
    });;
});

$(window).resize(function() {
  cleanMenu();
});